/*global Modernizr, abc_map_styles, google, SVGMarker, InfoBox, branch_location, map_pin_svg, additional_locations */
/*jslint browser:true */

(function() {
  'use strict';

  var map_container = document.querySelector('.map-location');
  var map_markers = [];
  //var bounds;

  if(map_container) {
    //Display the main city
  var position = new google.maps.LatLng(branch_location.lat, branch_location.lng);

  var map = new google.maps.Map(map_container, {
        zoom: 10,
        maxZoom: 17,
        center: position,
        mapTypeControl: false,
        panControl: false,
        streetViewControl: false,
        fullscreenControl: false,
        zoomControl: true,
        zoomControlOptions: {
          position: google.maps.ControlPosition.LEFT_BOTTOM
        },
        scaleControl: false,
        scrollwheel: false,
        styles: abc_map_styles
  });

  var marker = new SVGMarker({
    position: position,
    map: map,
    clickable: true,
    icon: {
      size: new google.maps.Size(20, 20),
      anchor: new google.maps.Point(10, 10),
      url: '/wp-content/themes/abc/images/dist/icons/map_pin.svg', // This one is not shown so we can animate it
      class: 'SVGMarker',
      html: convertToDom('<div class="map-marker">' + map_pin_svg + '</div>')
    }
  });

    var infobox_content = '<div class="map-tooltip">';
      infobox_content += '<a href="#" class="close"><svg class="icon" viewBox="0 0 24 24"><use xlink:href="#close"></use></svg></a>';
      infobox_content += '<div class="branch-name">' + branch_location.city + '</div>';
      infobox_content += '<p>' + branch_location.address + '</p>';

    if(branch_location.hours) {
      var days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

      infobox_content += '<h6>Hours</h6>';
      infobox_content += '<div class="location-hours">';

      branch_location.hours.forEach((hour_span) => {
        var hour_time = '';

        if(hour_span.closed) {
          hour_time = 'Closed';
        } else {
          hour_time += ((parseInt(hour_span.open_hour) >= 12)?parseInt(hour_span.open_hour) - 12:parseInt(hour_span.open_hour)) + ':' + hour_span.open_minutes + ((parseInt(hour_span.open_hour) >= 12)?'pm':'am');
          hour_time += ' - ';
          hour_time += ((parseInt(hour_span.close_hour) >= 12)?parseInt(hour_span.close_hour) - 12:parseInt(hour_span.close_hour)) + ':' + hour_span.close_minutes + ((parseInt(hour_span.close_hour) >= 12)?'pm':'am');
        }

        infobox_content += '<div class="grid-cell">';
          infobox_content += '<div class="location-hours-details">';
            infobox_content += '<div class="grid-cell days">' + (days[parseInt(hour_span.day_start)] + ((hour_span.day_end !== '')?'-'+days[parseInt(hour_span.day_end)]:'')) + '</div>';
            infobox_content += '<div class="grid-cell ' + ((hour_span.closed)?'closed':'open') + '">' + hour_time + '</div>';
          infobox_content += '</div>';
        infobox_content += '</div>';
      });

      infobox_content += '</div>';
    }

    infobox_content += '</div>';

    infobox_content = convertToDom(infobox_content);

    infobox_content.querySelector('.close').addEventListener('click', (e) => {
      e.preventDefault();

      infobox.close();
    });

    var infobox = new InfoBox({
      content: infobox_content,
      pixelOffset: new google.maps.Size(-216.5, -30),
      alignBottom: true,
      position: position,
      boxStyle: {
        width: '433px'
      },
      closeBoxURL: '',
      infoBoxClearance: new google.maps.Size(10, 10),
    });

    infobox.open(map);

    google.maps.event.addListener(marker, 'click', () => {
      if(infobox.getVisible()) {
        marker.container.classList.remove('infobox-open');
        infobox.close();
      } else {
        marker.container.classList.add('infobox-open');
        infobox.open(map);
      }
    });

    //add additional locations if they exist
    if(additional_locations) {
      process_locations(additional_locations);
    }

    function process_locations(additional_locations) {
      //bounds = new google.maps.LatLngBounds();

      map_markers.forEach((map_markers) => {
        map_markers.setMap(null);
      });
  
      map_markers = [];

      additional_locations.forEach((location) => {
        
        var marker_content = convertToDom('<div class="map-marker">' + map_pin_svg + '</div>');
 
        var marker_position = new google.maps.LatLng(location.lat, location.lng);

        var markers = new SVGMarker({
          position: marker_position,
          map: map,
          clickable: true,
          icon: {
            size: new google.maps.Size(20, 20),
            anchor: new google.maps.Point(10, 10),
            url: '/wp-content/themes/abc/images/dist/icons/map_pin.svg', // This one is not shown so we can animate it
            class: 'SVGMarker',
            html: marker_content
          }
        });

        var infobox_content_add = '<div class="map-tooltip">';
        infobox_content_add += '<a href="#" class="close"><svg class="icon" viewBox="0 0 24 24"><use xlink:href="#close"></use></svg></a>';
        infobox_content_add += '<div class="branch-name">';
        if(location.link) {
          infobox_content_add += '<a href="' + location.link + '">';
        }
        infobox_content_add += location.city;
        if(location.link) {
          infobox_content_add += '</a>';
        }
        infobox_content_add += '</div>';
        infobox_content_add += '<p>' + location.address + '</p>';
        infobox_content_add += '</div>';

        infobox_content_add = convertToDom(infobox_content_add);
    
        infobox_content_add.querySelector('.close').addEventListener('click', (e) => {
          e.preventDefault();
    
          infobox_add.close();
        });

        var infobox_add = new InfoBox({
          content: infobox_content_add,
          pixelOffset: new google.maps.Size(-216.5, -30),
          alignBottom: true,
          position: marker_position,
          boxStyle: {
            width: '433px'
          },
          closeBoxURL: '',
          infoBoxClearance: new google.maps.Size(10, 10),
        });

        google.maps.event.addListener(markers, 'click', () => {
          if(infobox_add.getVisible()) {
            markers.container.classList.remove('infobox-open');
            infobox_add.close();
          } else {
            markers.container.classList.add('infobox-open');
            infobox_add.open(map);
          }
        });
  
        //bounds.extend(marker_position);
  
        map_markers.push(markers);  
    });

    //map.fitBounds(bounds);
    }
  }

  function convertToDom(html) {
    var d = document.createElement('div');
    d.innerHTML = html;
    return d.firstChild;
  }
}());
